import { APIUrls } from "../../Constants/ApiUrls";
// import { IPatient } from "../../Models/IPatient"; //Fix Warning Complaint Code:071225
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const TraceController = {
  ListStatusData: async (
    startDate: string,
    maxDate: string,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.TRACES.TRACES_URL_LIST;
    request.method = "POST";
    request.payload = {
      startDate,
      maxDate,
    };
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  ListStatusDataAll: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.TRACES.TRACES_URL_LIST_ALL;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default TraceController;
